import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ForgeProxyModule } from '../forge-proxy/forge-proxy.module';
import { NotificationIconComponent } from './components/notification-icon/notification-icon.component';
import { NgIf, AsyncPipe } from "@angular/common";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { ErrorPageStateComponent } from "./components/error/error-page-state.component";
import { IsActivePipe } from "./pipes/is-active.pipe";
import { MugshotWebcamComponent } from './components/mugshot-webcam/mugshot-webcam.component';
import { WebcamModule } from "ngx-webcam";
import { AgePipe } from './pipes/age.pipe';
import { TimePipe } from './pipes/time.pipe';
import { MostRecentArrestingAgencyPipe } from './pipes/most-recent-arresting-agency.pipe';
import { NaPipe } from './pipes/na.pipe';
import { HeightPipe } from './pipes/height.pipe';
import { CamelToNormalPipe } from './pipes/camel-case-to-normal.pipe';

const imports = [
  ForgeProxyModule,
  NgIf,
  AsyncPipe,
  InfiniteScrollModule
];

@NgModule({
  imports: [
    ...imports,
    WebcamModule
  ],
  exports: [
    ...imports,
    NotificationIconComponent,
    ErrorPageStateComponent,
    IsActivePipe,
    AgePipe,
    TimePipe,
    MostRecentArrestingAgencyPipe,
    NaPipe,
    HeightPipe,
    MugshotWebcamComponent,
    CamelToNormalPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    NotificationIconComponent,
    ErrorPageStateComponent,
    IsActivePipe,
    AgePipe,
    TimePipe,
    NaPipe,
    MostRecentArrestingAgencyPipe,
    HeightPipe,
    MugshotWebcamComponent,
    CamelToNormalPipe
  ]
})
export class SharedModule {
}